import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Row, Col, Checkbox, Pagination, Spin, Empty } from '@tinper/next-ui';
import { iDataTableProps } from './iTableProps';
import CardItem from "./CardTableItem";
import '../Table.less';

const CardTable = function CardTable (props:iDataTableProps) {
  const {

    fillSpace,
    gutter,
    // addItemPosition,
    emptyText,
    emptyClassName = "",
    rowSelection,
    rowKey,
    fieldid,
    data,
    columnCount,
    columns,
    tableClassName,
    rowClassName,
    itemType,
    pagination,
    loading,
    // bordered,
    onRowClick,
    onRowDoubleClick
  } = props;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  useEffect(() => {
    if (rowSelection) {
      const { selectedRowKeys = [] } = rowSelection;
      setSelectedRowKeys(selectedRowKeys)
    }
  }, [rowSelection])

  function checkIsAllSelected () {
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      console.log(
        item[rowKey],
        "item[rowKey]",
        selectedRowKeys.includes(item[rowKey])
      );
      if (!selectedRowKeys.includes(item[rowKey])) {
        return false;
      }
    }
    return true;
  };
  const isAllChecked = useMemo(() => {
    return checkIsAllSelected();
  }, [selectedRowKeys])

  const onSelect = useCallback((checked, data) => {
    const { rowSelection = {}, rowKey } = props;
    const { onChange } = rowSelection;
    let newSelectedKeys = [...selectedRowKeys];
    if (rowSelection.type === "radio") {
      newSelectedKeys = checked ? [data[rowKey]] : [];
    } else {
      if (checked) {
        newSelectedKeys.push(data[rowKey]);
      } else {
        const findIndexKey = newSelectedKeys.findIndex((i) => i === data[rowKey]);
        newSelectedKeys.splice(findIndexKey, 1);
      }
    }
    setSelectedRowKeys(newSelectedKeys);
    onChange && onChange(newSelectedKeys);
  })

  const selectAll = useCallback(function (e) {
    const { rowKey, rowSelection = {}, data } = props;
    const selectedRowKeys = [];
    const selectedRows = [];
    const { onChange } = rowSelection;
    if (e.target.checked) {
      data.forEach((item) => {
        selectedRows.push(item);
        selectedRowKeys.push(item[rowKey]);
      });
    }
    setSelectedRowKeys(selectedRowKeys)
    onChange && onChange(selectedRowKeys, selectedRows);
  });

  const spanProps = useMemo(() => {
    const result = {};
    if (typeof columnCount === "number") {
      return {
        span: Math.floor(24 / columnCount)
      };
    } else if (typeof columnCount === "object") {
      for (const key in columnCount) {
        result[key] = Math.floor(24 / columnCount[key]);
      }
    }
    return result;
  }, [columnCount]);

  const pageConfig = useMemo(() => {
    return {
      ...pagination,
      onChange: (page) => {
        props.onChange({
          ...pagination,
          current: page
        })
      },
      onPageSizeChange: (current, size) => {
        props.onChange({
          ...pagination,
          current,
          pageSize: size
        })
      }
    }
  })

  return <div className={`as-cardTable-container ${tableClassName} ${!fillSpace ? "as-cardTable-container-nospace" : ""}`}>
    {rowSelection && rowSelection.type === "checkbox"
      ? (
        <div style={{ position: "absolute", bottom: 24 }}>
          <Checkbox onClick={selectAll} checked={isAllChecked} fieldid={`${fieldid}_selectallbtn`}>
                全选
          </Checkbox>{" "}
        </div>
      )
      : null}
    <div className={`as-cardTable-content ${data?.length ? "" : "as-cardTable-empty-context"} ${
      fillSpace && pagination ? "as-cardTable-content-page-fixed" : fillSpace && !pagination ? "as-cardTable-content-page-fill" : "as-cardTable-content-page-nofill"
    }`}>
      {
        data.length
          ? (<Row gutter={gutter}>
            {data.map((data, index) => {
              return (
                <Col {...spanProps} className={rowClassName} key={index}>
                  {typeof itemType === "function"
                    ? (
                      itemType(data, index)
                    )
                    : (
                      <CardItem
                        {...props}
                        columns={columns}
                        data={data}
                        index={index}
                        key={index}
                        selectedRowKeys={selectedRowKeys}
                        onSelect={onSelect}
                        onRowDoubleClick={onRowDoubleClick}
                        onRowClick={onRowClick}

                      />
                    )}
                </Col>
              );
            })}
          </Row>)
          : <Empty fieldid={`${fieldid}_empty_text`} description={emptyText} className={emptyClassName}/>
      }

    </div>
    <Spin spinning={loading} />
    <div
      className={`as-cardTable-pagination ${
        fillSpace ? "as-cardTable-pagination-fixed" : ""
      }`}
    >
      {pagination && pagination.total
        ? (
          <Pagination {...pageConfig}></Pagination>
        )
        : null}
    </div>
  </div>
};

export default CardTable;